import React, { useEffect, useRef, useState } from 'react';

let toastId = 0;
let globalAddToast = null;

export function showToast(message, type = 'default') {
  if (globalAddToast) globalAddToast({ id: ++toastId, message, type });
}

export function showAlert(title, message, buttons) {
  // Simple confirm-style dialog for destructive actions
  if (buttons && buttons.length > 1) {
    const destructive = buttons.find(b => b.style === 'destructive');
    const cancel = buttons.find(b => b.style === 'cancel');
    if (destructive) {
      if (window.confirm(`${title}\n\n${message}`)) {
        destructive.onPress?.();
      } else {
        cancel?.onPress?.();
      }
      return;
    }
  }
  showToast(message || title, 'default');
}

const Toast = ({ message, type, onRemove }) => {
  useEffect(() => {
    const t = setTimeout(onRemove, 2800);
    return () => clearTimeout(t);
  }, [onRemove]);

  return (
    <div className={`toast toast--${type}`} onClick={onRemove}>
      {message}
    </div>
  );
};

export const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);
  const addRef = useRef(null);

  addRef.current = (toast) => setToasts(prev => [...prev, toast]);

  useEffect(() => {
    globalAddToast = (t) => addRef.current(t);
    return () => { globalAddToast = null; };
  }, []);

  const remove = (id) => setToasts(prev => prev.filter(t => t.id !== id));

  return (
    <div className="toast-container">
      {toasts.map(t => (
        <Toast key={t.id} {...t} onRemove={() => remove(t.id)} />
      ))}
    </div>
  );
};

export default ToastContainer;
